import { Box, TextNew as Text } from '@jfs/ui-new'

const CVVToolTip = ({
  visible,
  isSubscriptionEnabled = false,
}: {
  visible: boolean
  isSubscriptionEnabled?: boolean
}) => {
  return (
    <>
      {visible ? (
        <Box
          borderRadius={'5px'}
          width={'175px'}
          p={'LARGE'}
          position={'absolute'}
          right={55}
          bottom={45}
          zIndex={100}
          backgroundColor={'BLACK'}>
          <Text type={'body12'} color={'BG_PRIMARY'} fontFamily="jioType-Medium">
            {
              'Your card details would be tokenized and securely saved as per RBI guideline for faster payments. Your CVV number will not be saved.'
            }
          </Text>
          <Box
            width="0"
            height="0"
            position={'absolute'}
            bottom="-10"
            left={70}
            borderWidth={20}
            borderBottomWidth={0}
            borderLeftColor="TRANSPARENT"
            borderRightColor="TRANSPARENT"
            borderTopColor="BLACK"
          />
        </Box>
      ) : null}
    </>
  )
}

export { CVVToolTip }
